<template>
    <OmniButton :disabled="isRegenerateTriggerCacheButtonDisabled"
              @click="regenerateTriggerCache"
              class="regenerate-trigger-cache"
        >
        <span>
            <template v-if="processing">
                <span class="icon"><font-awesome-icon icon="sync-alt" spin /></span>
                <span class="label">{{ $t("omt.gui.triggers.status.refreshing-trigger-cache") }}</span>
            </template>

            <template v-else>
                <span class="icon"><font-awesome-icon icon="sync-alt" /></span>
                <span class="label">{{ $t("omt.gui.triggers.action.refresh-trigger-cache") }}</span>
            </template>
        </span>
    </OmniButton>
</template>

<style lang="scss">
.omni-btn.regenerate-trigger-cache {
    padding: .5rem 1rem;
}

.regenerate-trigger-cache {
    .icon {
        margin-right: .5rem;
    }
}

.loader {
    font-size: 12px;
    line-height: 18px;
}
</style>

<script>
export default {
    name: "RefreshTriggerCacheButton",
    data() {
        return {
            processing: false,
        };
    },
    methods: {
        regenerateTriggerCache() {
            this.processing = true;
            this.$http
                .post("/api/trigger-cache", {})
                .then((response) => {
                    switch (response.status) {
                        case 200:
                            this.$alert(this.$t("omt.gui.triggers.response-message.status-200"));
                            break;
                        case 201:
                            this.$alert(this.$t("omt.gui.triggers.response-message.status-201"));
                            break;
                    }
                })
                .catch((error, response) => {
                    this.$alert(this.$t("omt.gui.triggers.response-message.error-general"), "error");
                    console.error(`regenerateTriggerCache: ${error}`);
                })
                .finally(() => {
                    this.processing = false;
                });
        },
    },

    computed: {
        isRegenerateTriggerCacheButtonDisabled() {
            // Disable the button when the user is not allowed to edit triggers,
            // or when the API is currently processing a request.
            return this.processing || !this.hasPermission("triggers.edit");
        },
    },
};
</script>
